import { gql } from "@apollo/client";

export const GET_RECORD_TRACE_CONCIG_OCASSIONALLY = gql`
  query FindByEmailOcassionally(
    $email: String!
    $position: String!
    $userId: Float!
  ) {
    findByEmailOcassionally(
      email: $email
      position: $position
      userId: $userId
    ) {
      title
      description
      recordPointId
      startDate
      endDate
      recordFields
      name
      branchName
      users {
        userId
        email
        profilePicture
        fullName
      }
    }
  }
`;

export const GET_USERS_BY_ID_QUERY = gql`
  query GetUsers($userIds: [Int!]!) {
    users(userIds: $userIds) {
      userId
      potpis
      fullName
    }
  }
`;

export const GET_RECORD_POINTS_BY_BRANCH_ID = gql`
  query RecordPointsByBranchId(
    $branchId: Int!
    $startDate: DateTime!
    $endDate: DateTime!
  ) {
    recordPointsByBranchId(
      branchId: $branchId
      startDate: $startDate
      endDate: $endDate
    ) {
      recordPointId
      createdAt
      updatedAt
      deletedAt
      startDate
      endDate
      name
      url
      qrCode
      accessRights
      active
      stages

      CIPOEvd {
        cipoEvdId
        userId
        createdAt
        imePrezime
        potpisano
        type
        datum
      }

      CIPPEvd {
        cippEvdId
        userId
        createdAt
        imePrezime
        potpisano
        datum
      }

      DezinfekcijaEvd {
        dezinfekcijaEvdId
        userId
        createdAt
        imePrezime
        potpisano
        slikaDeklaracije
        datum
      }

      DezinsekcijaEvd {
        dezinsekcijaEvdId
        userId
        createdAt
        imePrezime
        potpisano
        slikaDeklaracije
        datum
      }

      DezinsekcijaEvd_Kontrola {
        dezinsekcijaEvd_KontrolaId
        userId
        createdAt
        imePrezime
        potpisano
        opisKontrole
        stanjeKontrole
        datum
      }

      DezinsekcijaEvd_Korekcija {
        dezinsekcijaEvd_KorekcijaId
        userId
        createdAt
        imePrezime
        potpisano
        opisKorekcije
        stanjeKorekcije
        datum
      }

      DeratizacijaEvd {
        deratizacijaEvdId
        userId
        createdAt
        imePrezime
        potpisano
        slikaDeklaracije
        datum
      }

      DeratizacijaEvd_Kontrola {
        deratizacijaEvd_KontrolaId
        userId
        createdAt
        imePrezime
        potpisano
        opisKontrole
        stanjeKontrole
        datum
      }

      DeratizacijaEvd_Korekcija {
        deratizacijaEvd_KorekcijaId
        userId
        createdAt
        imePrezime
        potpisano
        opisKorekcije
        stanjeKorekcije
        datum
      }

      DezSrEvd {
        dezSrEvdId
        createdAt
        updatedAt
        naziv
        vrsta
        primjena
        upustvoZaUpotrebu
        slika
        userId
        imePrezime
        potpisano
      }

      DobavljacEvd {
        dobavljacEvdId
        createdAt
        updatedAt
        imePrezime
        potpisano
        name
        userId
        address
        phoneNumber
        idTax
        pdvTax
        productType
      }

      DostavaEvd {
        dostavaEvdId
        createdAt
        updatedAt
        datum
        vrijeme
        posiljalac
        brojRacuna
        primalac
        ispravnaPosiljka
        primjedba
        userId
        korektivnaMjera
        dokument
        potpisPosiljalac
        potpisPrimalac
      }

      EduZapEvd {
        eduZapEvdId
        createdAt
        updatedAt
        datumObuke
        mjestoObuke
        tip
        izvrsilacObuke
        tema
        cilj
        userId
        verifikacijaEfikasnosti
        imePrezime
        radnoMjesto
        verifikacijaPrisustvaPotpis
        verifikacijaEdukatoraPotpis
        dokument
      }

      MolEvd {
        molEvdId
        createdAt
        updatedAt
        imePrezime
        potpisano
        datum
        opis
        userId
        izvrsioc
        potpisIzvrsioca
        datum
      }

      PrijemRobeEvd {
        prijemRobeEvdId
        createdAt
        updatedAt
        userId
        primalac
        potpisano
        datum
        posiljalac
        potpisPosiljalac
        ispravnaPosiljka
        dokument
        primjedba
        korektivnaMjera
        temperatura
        datum
      }

      SanEvd {
        sanEvdId
        createdAt
        updatedAt
        imePrezime
        potpisano
        uposlenik
        dokument
        vaziOd
        vaziDo
      }

      OpremaEvd {
        opremaEvdId
        createdAt
        updatedAt
        imePrezime
        potpisano
        tip
        datum
        vrijeme
        izvrsioc
        potpisIzvrsioca
        opis
        userId
      }

      OtpadEvd {
        otpadEvdId
        createdAt
        updatedAt
        imePrezime
        userId
        potpisano
        datum
        vrijeme
        vrstaOtpada
        kolicina
        jedinicaMjere
        primaoc
        potpisPrimaoc
        adekvatnoPrikupljen
        korektivnaMjera
      }

      TemperaturaEvd {
        temperaturaEvdId
        createdAt
        updatedAt
        imePrezime
        potpisano
        userId
        ocitanaTemperatura
        dozvoljenaTempMin
        dozvoljenaTempMax
        dozvoljenoOdstupanje
        datum
        vrijeme
      }

      TemperaturaOgranicenaEvd {
        temperaturaOgranicenaEvdId
        createdAt
        updatedAt
        imePrezime
        potpisano
        userId
        ocitanaTemperatura
        napomena
        datum
      }

      TemperaturaOgranicenaKKTEvd {
        temperaturaOgranicenaKKTEvdId
        createdAt
        updatedAt
        imePrezime
        potpisano
        userId
        ocitanaTemperatura
        datum
        korektivnaMjera
        nakonKorekcijeTemperatura
      }

      TemperaturaKKTProizvodiEvd {
        temperaturaKKTProizvodiEvdId
        createdAt
        updatedAt
        imePrezime
        potpisano
        userId
        ocitanaTemperatura
        datum
        korektivnaMjera
        nakonKorekcijeTemperatura
        proizvod
      }

      CheckListEvd {
        checkListEvdId
        createdAt
        updatedAt
        datum
        imePrezime
        potpisano
        userId
        checklistjson
        dokument
      }

      RecordTraceConfig {
        recordTraceConfigId
        createdAt
        updatedAt
        deletedAt
        recordFields
        status
        branches
        fkUserId
        fkBranchId
        typeList
        label
        category
        revizija
        title
        description
        descriptionMarkdown
        tempConfig {
          dozvoljenoOdstupanje
          dozvoljenaTempMax
          dozvoljenaTempMin
        }
        config {
          recordPoints {
            recordPoint
            selected
          }
          frequency {
            type
            startDate
            endDate
            occurrance
            beginDate
          }
          users {
            recordPoint
            category
          }
        }
      }
    }
  }
`;

export const FIND_RECORD_POINT_BY_NAME = gql`
  query FindRecordPointByName(
    $name: String!
    $startDate: DateTime!
    $endDate: DateTime!
    $branchId: Float!
  ) {
    findRecordPointByName(
      name: $name
      startDate: $startDate
      endDate: $endDate
      branchId: $branchId
    ) {
      recordPointId
      createdAt
      updatedAt
      deletedAt
      startDate
      endDate
      name
      url
      qrCode
      accessRights
      active
      stages

      CIPOEvd {
        cipoEvdId
        userId
        createdAt
        imePrezime
        potpisano
        type
        datum
      }

      CIPPEvd {
        cippEvdId
        userId
        createdAt
        imePrezime
        potpisano
        datum
      }

      DezinfekcijaEvd {
        dezinfekcijaEvdId
        userId
        createdAt
        imePrezime
        potpisano
        slikaDeklaracije
        datum
      }

      DezinsekcijaEvd {
        dezinsekcijaEvdId
        userId
        createdAt
        imePrezime
        potpisano
        slikaDeklaracije
        datum
      }

      DezinsekcijaEvd_Kontrola {
        dezinsekcijaEvd_KontrolaId
        userId
        createdAt
        imePrezime
        potpisano
        opisKontrole
        stanjeKontrole
        datum
      }

      DezinsekcijaEvd_Korekcija {
        dezinsekcijaEvd_KorekcijaId
        userId
        createdAt
        imePrezime
        potpisano
        opisKorekcije
        stanjeKorekcije
        datum
      }

      DeratizacijaEvd {
        deratizacijaEvdId
        userId
        createdAt
        imePrezime
        potpisano
        slikaDeklaracije
        datum
      }

      DeratizacijaEvd_Kontrola {
        deratizacijaEvd_KontrolaId
        userId
        createdAt
        imePrezime
        potpisano
        opisKontrole
        stanjeKontrole
        datum
      }

      DeratizacijaEvd_Korekcija {
        deratizacijaEvd_KorekcijaId
        userId
        createdAt
        imePrezime
        potpisano
        opisKorekcije
        stanjeKorekcije
        datum
      }

      DezSrEvd {
        dezSrEvdId
        createdAt
        updatedAt
        naziv
        vrsta
        primjena
        upustvoZaUpotrebu
        slika
        userId
        imePrezime
        potpisano
      }

      DobavljacEvd {
        dobavljacEvdId
        createdAt
        updatedAt
        imePrezime
        potpisano
        name
        userId
        address
        phoneNumber
        idTax
        pdvTax
        productType
      }

      DostavaEvd {
        dostavaEvdId
        createdAt
        updatedAt
        datum
        vrijeme
        posiljalac
        brojRacuna
        primalac
        ispravnaPosiljka
        primjedba
        userId
        korektivnaMjera
        dokument
        potpisPosiljalac
        potpisPrimalac
      }

      EduZapEvd {
        eduZapEvdId
        createdAt
        updatedAt
        datumObuke
        mjestoObuke
        tip
        izvrsilacObuke
        tema
        cilj
        userId
        verifikacijaEfikasnosti
        imePrezime
        radnoMjesto
        verifikacijaPrisustvaPotpis
        verifikacijaEdukatoraPotpis
        dokument
      }

      MolEvd {
        molEvdId
        createdAt
        updatedAt
        imePrezime
        potpisano
        datum
        opis
        userId
        izvrsioc
        potpisIzvrsioca
        datum
      }

      PrijemRobeEvd {
        prijemRobeEvdId
        createdAt
        updatedAt
        userId
        primalac
        potpisano
        datum
        posiljalac
        potpisPosiljalac
        ispravnaPosiljka
        dokument
        primjedba
        korektivnaMjera
        temperatura
        datum
      }

      SanEvd {
        sanEvdId
        createdAt
        updatedAt
        imePrezime
        potpisano
        uposlenik
        dokument
        vaziOd
        vaziDo
      }

      TemperaturaEvd {
        temperaturaEvdId
        createdAt
        updatedAt
        imePrezime
        potpisano
        userId
        ocitanaTemperatura
        dozvoljenaTempMin
        dozvoljenaTempMax
        dozvoljenoOdstupanje
        datum
        vrijeme
      }

      TemperaturaOgranicenaEvd {
        temperaturaOgranicenaEvdId
        createdAt
        updatedAt
        imePrezime
        potpisano
        userId
        napomena
        ocitanaTemperatura
        datum
      }

      TemperaturaOgranicenaKKTEvd {
        temperaturaOgranicenaKKTEvdId
        createdAt
        updatedAt
        imePrezime
        potpisano
        userId
        ocitanaTemperatura
        datum
        korektivnaMjera
        nakonKorekcijeTemperatura
      }

      OtpadEvd {
        otpadEvdId
        createdAt
        updatedAt
        imePrezime
        userId
        potpisano
        datum
        vrijeme
        vrstaOtpada
        kolicina
        jedinicaMjere
        primaoc
        potpisPrimaoc
        adekvatnoPrikupljen
        korektivnaMjera
      }

      TemperaturaOgranicenaEvd {
        temperaturaOgranicenaEvdId
        createdAt
        updatedAt
        imePrezime
        potpisano
        userId
        ocitanaTemperatura
        napomena
        datum
      }

      OpremaEvd {
        opremaEvdId
        createdAt
        updatedAt
        imePrezime
        potpisano
        tip
        datum
        vrijeme
        izvrsioc
        potpisIzvrsioca
        opis
        userId
      }

      CheckListEvd {
        checkListEvdId
        createdAt
        updatedAt
        datum
        imePrezime
        potpisano
        userId
        checklistjson
        dokument
      }

      TemperaturaKKTProizvodiEvd {
        temperaturaKKTProizvodiEvdId
        createdAt
        updatedAt
        imePrezime
        potpisano
        userId
        ocitanaTemperatura
        datum
        korektivnaMjera
        nakonKorekcijeTemperatura
        proizvod
      }

      RecordTraceConfig {
        recordTraceConfigId
        createdAt
        updatedAt
        deletedAt
        recordFields
        status
        revizija
        branches
        fkUserId
        fkBranchId
        typeList
        label
        category
        title
        description
        descriptionMarkdown
        tempConfig {
          dozvoljenoOdstupanje
          dozvoljenaTempMax
          dozvoljenaTempMin
        }
        config {
          recordPoints {
            recordPoint
            selected
          }
          frequency {
            type
            startDate
            endDate
            occurrance
            beginDate
          }
          users {
            recordPoint
            category
          }
        }
      }
    }
  }
`;
